import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface BatchApprovalData {
  ApplicantId?: any;
  TitleId: number;
  LastName: string;
  FirstName: string;
  MiddleName: string;
  Email: string;
  PhoneNumber: string;
  CorprateName?: any;
  StateCode?: any;
  StartDate?: any;
  isCorporate?: any;
  DateBirth?: any;
  ContactAddress?: any;
  StateOriginId?: any;
  LGAId?: any;
  StateId?: any;
  ZoneId?: any;
  NYSCUploadDocumentUrl?: any;
  GenderId?: any;
  MaritalStatusId?: any;
  IsChangeofName?: any;
  UploadPictureUrl?: any;
  UploadChangeofNameUrl?: any;
  TabId?: any;
  IsSubmitted: boolean;
  RouteId: number;
  AppMemberId: string;
  TargetedMembers?: any;
  TargetedMembersId: number;
  ApprovalRoleId: string;
  ApprovalIndex: number;
  Status: number;
  FinalApproval: number;
  RouteName: string;
  AppprovalComment?: any;
  ApprovalActionTypes: number;
  AppprovalAction?: any;
  ApprovalActionTypeId?: any;
}

interface BatchApprovalRoot{
    data: BatchApprovalData[]
}

const initialState: BatchApprovalRoot = {
    data: []
}

export const batchApprovalSlice = createSlice({
    name: 'batchApproval',
    initialState,
    reducers: {
        setAllBatchApproval: (state, action: PayloadAction<BatchApprovalData[]>) => {
           state.data = action?.payload
        
        },
        removeAllBatchApproval: (state) => {
            // state = [];
        },
    }
});

export const {setAllBatchApproval, removeAllBatchApproval} = batchApprovalSlice.actions;

export default batchApprovalSlice.reducer;